var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 120,
    viewBox: "0 0 121 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 39.2C20.5 32.4794 20.5 29.1191 21.8079 26.5521C22.9584 24.2942 24.7942 22.4584 27.0521 21.3079C29.6191 20 32.9794 20 39.7 20H81.3C88.0206 20 91.3809 20 93.9479 21.3079C96.2058 22.4584 98.0416 24.2942 99.1921 26.5521C100.5 29.1191 100.5 32.4794 100.5 39.2V80.8C100.5 87.5206 100.5 90.8809 99.1921 93.4479C98.0416 95.7058 96.2058 97.5416 93.9479 98.6921C91.3809 100 88.0206 100 81.3 100H39.7C32.9794 100 29.6191 100 27.0521 98.6921C24.7942 97.5416 22.9584 95.7058 21.8079 93.4479C20.5 90.8809 20.5 87.5206 20.5 80.8V39.2Z",
    fill: "#FDF0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8335 59.9997L75.086 50.7472C75.867 49.9662 75.867 48.6999 75.086 47.9188L72.5811 45.4139C71.8 44.6329 70.5337 44.6329 69.7526 45.4139L60.5002 54.6664L51.2477 45.4139C50.4667 44.6329 49.2004 44.6329 48.4193 45.4139L45.9144 47.9188C45.1334 48.6999 45.1334 49.9662 45.9144 50.7473L55.1668 59.9997L45.9144 69.2521C45.1334 70.0332 45.1334 71.2995 45.9144 72.0806L48.4193 74.5855C49.2004 75.3665 50.4667 75.3665 51.2477 74.5855L60.5002 65.333L69.7526 74.5855C70.5337 75.3665 71.8 75.3665 72.5811 74.5855L75.086 72.0806C75.867 71.2995 75.867 70.0332 75.086 69.2522L65.8335 59.9997Z",
    fill: "url(#paint0_linear_532_16648)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_532_16648",
    x1: 60.5002,
    y1: 43.9997,
    x2: 60.5002,
    y2: 75.9997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED827E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC6876"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorLarge);
export default __webpack_public_path__ + "static/media/errorLarge.f3870ef7e0b6dd0ec71ffc7417df69d9.svg";
export { ForwardRef as ReactComponent };